import React, {useEffect, useState} from "react";
import { UpdateFieldFn, Golfer } from "../types/types";
import { useNavigate, useLocation } from "react-router-dom";
import { usaStates } from "../utils/utils";
import Footer from "./shared/Footer";
import { normalizeInput, formatDOB, convertFromISOToUS, isValidDOB } from "../utils/utils";
import { usePageContent } from "../api/usePageContent";

interface Step3Props {
  formData: Golfer;
  updateField: UpdateFieldFn;
}

interface LocationState {
  golfer?: Golfer;
}


const Step4: React.FC<Step3Props> = ({ formData, updateField }) => {
  const { title: pageTitle, overview: pageOverview } = usePageContent("step4");
  const navigate = useNavigate();
  const location = useLocation();
  const selectedContact = location.state.golfer;

    const state = (location.state || {}) as LocationState;
  
    const [golfer, setGolfer] = useState<Golfer | null>(
      state.golfer ?? null
    );

    console.log(location.state);
  
  useEffect(() => {
     if (state.golfer) {
       updateField("id", state.golfer?.id as any || "");
       updateField("firstName", state.golfer?.firstName || "");
       updateField("lastName", state.golfer?.lastName || "");
       updateField("email", state.golfer?.email || "");
       updateField("phone", normalizeInput(state.golfer?.phone));
       updateField("sex", state.golfer?.sex || "");
       if (state.golfer.id) {
         updateField("id", state.golfer.id as any || '');
       }
       if (state.golfer?.date_of_birth && state.golfer?.date_of_birth.includes("-")) {
         updateField("date_of_birth", convertFromISOToUS(state.golfer?.date_of_birth));
       } else {
         updateField("date_of_birth", (state.golfer?.date_of_birth || ""));
       }
       updateField("address", state.golfer?.address || "");
       updateField("street_address_2", state.golfer?.street_address_2 || "");
       updateField("city", state.golfer?.city || "");
       updateField("state", state.golfer?.state || "VA");
       updateField("zip", state.golfer?.zip || "");

       updateField("bagTag", !!state.golfer?.bagTag);
      updateField("donation", !!state.golfer?.donation);
      updateField("personalization", state.golfer?.personalization || '');
      updateField("donation_amount", state.golfer?.donation_amount || 0);

       updateField("vip_card_type", state.golfer?.vip_card_type || "");
       updateField("vip_package", state.golfer?.vip_package || "");
       updateField("ghinNumber", state.golfer?.ghinNumber || "");
       updateField("product_id", state.golfer?.product_id || "");
     }
   }, []); 



    const handleFieldChange = (field: keyof Golfer) => 
        (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
          const value = e.target.value;
      
          // 1. update your global form data
          updateField(field, value);
    
          // 2. also keep local golfer in sync
          setGolfer((prev) => {
            const base = prev ?? {};
      
            // map FormData field name ⇒ Golfer field name
            if (field === "address") {
              return { ...base, address: value };
            }
            if (field === "street_address_2") {
              return { ...base, street_address_2: value };
            }
            if (field === "city") {
              return { ...base, city: value };
            }
            if (field === "state") {
              return { ...base, state: value };
            }
            if (field === "zip") {
              return { ...base, zip: value };
            }      
            return prev;
          });
        };
    




    const handleZipChange = (e: React.KeyboardEvent<HTMLInputElement>) => {
      const digitsOnly = e.currentTarget.value.replace(/\D/g, ""); // remove non-numbers
      updateField("zip", digitsOnly);
    };


const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
  
    // build an updated golfer from the latest formData if you want to be explicit:
    const updatedGolfer: Golfer | null = golfer
      ? {
          ...golfer,
          firstName: formData.firstName || "",
          lastName: formData.lastName || "",
          email: formData.email || "",
          phone: formData.phone || "",
          sex: formData.sex || "",
          date_of_birth: formData.date_of_birth || "",
          address: formData.address || "",
          street_address_2: formData.street_address_2 || "",
          city: formData.city || "",
          state: formData.state || "",
          zip: formData.zip || "",
          id: formData.id as any || "",
          bagTag: formData.bagTag || false,
          donation: formData.donation || false,
          personalization: formData.personalization || "",
          donation_amount: formData.donation_amount || 0,
          vip_package: formData.vip_package || "",
          vip_card_type: formData.vip_card_type || "",
          ghinNumber: formData.ghinNumber || "",
          product_id: formData.product_id || ""
        }
      : null;
  
    navigate("/step5", {
      state: {
        ...state,            // keep anything else (admin, etc.)
        golfer: updatedGolfer,
      },
    });
  };

  return (
    <div className="container mt-5">

    <section className="vip-step3 container my-5">
      <div className="row justify-content-center">

    <div className="col-lg-12">

    <h3 className="mb-3 text-uppercase">
  {pageTitle || "Purchase a VIP Card"}
</h3>
{(pageOverview !== undefined ? pageOverview : "The VIP Card offers golfers exclusive discounted rates at approximately 200 courses throughout Virginia and West Virginia. A portion of the proceeds go to support the VSGA-VIP Scholarship Foundation.") && (
  <p className="mb-4">
    {pageOverview || "The VIP Card offers golfers exclusive discounted rates at approximately 200 courses throughout Virginia and West Virginia. A portion of the proceeds go to support the VSGA-VIP Scholarship Foundation."}
  </p>
)}



      <div className="col-12">
        <div className="card-body">

         
       {/* Grey Bar Section Title */}
        <div
            className="bg-light border px-3 py-2 mb-4 text-uppercase fw-semibold"
            style={{ fontSize: "0.9rem" }}
          >
            Address Information
          </div>

          {/* Subtitle */}
          <p className="text-start mb-4">
            Below is the information we have on record for your account. Please update any information that has changed. When you have finished, click the 'Next' button to complete the form. 
          </p>


      {golfer?.ghinNumber != "" ? 
        <>
        <div className="alert alert-light d-flex align-items-center" role="alert">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-info-circle" viewBox="0 0 16 16" id="circle">
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
            <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
          </svg>
          
          <div className="px-2">NOTE: Personal information updated on this form will update your GHIN profile.</div>
        </div>
        </>  
        : ''}


          <form id="step3-form" className="row gy-3" onSubmit={handleSubmit}>

              
            <div className="col-12">
              <label className="form-label" htmlFor="street">Street Address</label>
              <input 
                type="text"
                id="address"
                name="address"
                className="form-control"
                placeholder="123 Main St"
                value={formData.address}
                onChange={handleFieldChange("address")}
                required
              />
            </div>

            <div className="col-12">
            <label className="form-label" htmlFor="street">Street Address 2</label>
              <input 
                type="text"
                id="street_address_2"
                name="street_address_2"
                className="form-control"
                placeholder="123 Main St"
                value={formData.street_address_2}
                onChange={handleFieldChange("street_address_2")}
                
              />
            </div>

   
            <div className="col-md-6">
              <label className="form-label" htmlFor="city">City</label>
              <input 
                type="text"
                id="city"
                name="city"
                className="form-control"
                placeholder="Richmond"
                value={formData.city}
                onChange={handleFieldChange("city")}
                required
              />
            </div>

     
            <div className="col-md-3">
              <label className="form-label" htmlFor="state">State</label>
              <select name="state" className="form-select" id="state" onChange={handleFieldChange("state")} value={formData.state} required >             
                  <option value="">Please select state</option>
                  {usaStates.map((option, index) =>(
                  <option value={option.value} key={index}>{option.label}</option>
                  ))}
              </select>  
            </div>


            <div className="col-md-3">
              <label className="form-label" htmlFor="zip">ZIP Code</label>
              <input 
                type="text"
                id="zip"
                name="zip"
                className="form-control"
                placeholder="Enter zip code"
                value={formData.zip}
                onChange={handleFieldChange("zip")}
                maxLength={5}
                required
                pattern="[0-9]*"
                inputMode="numeric"
                onKeyUp={handleZipChange}
              />
            </div>

        
            <div className="col-12 d-flex justify-content-between mt-4">
            <button
                type="button"
                id="step4-back"
                className="btn btn-link text-decoration-none px-0"
                onClick={() =>
                  navigate("/step3", {
                    state: {
                      ...location.state,          // preserve all routing state
                      golfer: location.state?.golfer ?? null  // updated golfer stays
                    }
                  })
                }
              >
                ← Back
              </button>

              <button 
                type="submit"
                className="btn btn-primary px-4"
              >
                Next
              </button>
            </div>

          </form>

        </div>
      </div>
    </div>
  </div>
  {/* FOOTER NOTE */}
  <Footer />
</section>
    </div>
  );
};

export default Step4;
